import React from 'react'
import { useLocalSearchParams } from 'expo-router'
import { SupportScreen } from '../../../../components/settings/SupportScreen'
export default function SupportTicketScreen() {
  const { id } = useLocalSearchParams<{ id: string }>()
  return <SupportScreen key={id} ticketId={id} />
}
